<template>
  <MedicalHistoryVisitList :patient-id="patientId" />
</template>

<script>
import MedicalHistoryVisitList from '@/components/shared/MedicalHistoryVisitList.vue'

export default {
  name: 'ConsultationMedicalHistoryPage',
  components: { MedicalHistoryVisitList },
  computed: {
    patientId() {
      return this.$route.params.patient_id
    },
  },
}
</script>
